import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { Country, State } from 'country-state-city';
import config from '../../../config/config'
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import Dropzone from 'react-dropzone';
function AddUpdateUser(props) {
    const rawParams = useParams();
    const id = rawParams.id ?? '0'; // or Number(rawParams.id ?? 0);
    const navigate = useNavigate();
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [propertyOptions, setPropertyOptions] = useState([]);
    const [fileNames, setFileNames] = useState([]);
     const userId = localStorage.getItem("userId");
    const userType = localStorage.getItem("userType");
    const [formData, setFormData] = useState({
        propertyId:'',
        name: '',
        phone: '',
        email: '',
        country: '',
        state: '',
        pincode: '',
        address: '',
        image: [],
        userType:userType
    });

    const [errors, setErrors] = useState({});
    useEffect(() => {
        
         let data={userId:userId,userType:userType}
        config.getAllProperty(data).then((res) => {
            setPropertyOptions(res.data); // Ensure it's an array of { id, name }
        });
    }, []);
    useEffect(() => {
        setCountries(Country.getAllCountries());
        if (id !== 0) {
            config.getUserById({ id }).then((response) => {
                const res = response.data;

                // Set states for the selected country
                if (res.country) {
                    const statesList = State.getStatesOfCountry(res.country);
                    setStates(statesList);
                }

                // Update form data
                setFormData({
                    propertyId: res.propertyId || '',
                    name: res.name || '',
                    phone: res.phone || '',
                    email: res.email || '',
                    country: res.country || '',
                    state: res.state || '',
                    pincode: res.pincode || '',
                    address: res.address || '',
                    image: res.image ? res.image.split(',') : [],
                    // use nullish coalescing so that a stored value of 0 isn't
                    // treated as "falsy" and replaced by the localStorage value
                    userType: String(res.userType ?? userType),
                });
      setFileNames(res.image ? res.image.split(',') : []);
            }).catch((error) => {
                console.error('Error fetching user:', error);
            });
        }
    }, []);
    ;
    const handleCountryChange = (e) => {
        const countryCode = e.target.value;
        setFormData({ ...formData, country: countryCode, state: '' });
        setStates(State.getStatesOfCountry(countryCode));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.propertyId.trim()) newErrors.propertyId = 'Property is required';
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
        // if (!formData.email.trim()) newErrors.email = 'Email is required';
        if (!formData.country) newErrors.country = 'Country is required';
        if (!formData.state) newErrors.state = 'State is required';
        if (!formData.pincode.trim()) newErrors.pincode = 'Pincode is required';
        if (!formData.address.trim()) newErrors.address = 'Address is required';
        if (!formData.image) newErrors.image = 'Image is required';
         if (!formData.userType) newErrors.userType = 'Role is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            Swal.fire('Validation Error', 'Please correct the highlighted fields.', 'warning');
        } else {
            setErrors({});
        //           const formPayload = new FormData();
        // Object.entries(formData).forEach(([key, value]) => {
        //     formPayload.append(key, value);
        // });
            try {
                let response;
                if (id !== '0') {
                    const payload = { ...formData, id };
                    response = await config.createUser(payload); // Update user

                    Swal.fire({ text: response.data.message || 'User updated successfully!', icon: response.data.icon }).then((result) => {
                        if (result.isConfirmed) {
                            navigate(-1);
                        }
                    });
                } else {
                    response = await config.createUser(formData); // Add new user
                    Swal.fire({ text: response.data.message || 'User added successfully!', icon: response.data.icon }).then((result) => {
                        if (result.isConfirmed) {
                            navigate(-1);
                        }
                    });

                    setFormData({
                        propertyId:'',
                        name: '',
                        phone: '',
                        email: '',
                        country: '',
                        state: '',
                        pincode: '',
                        address: '',
                        userType:userType
                    });
                    setStates([]);
                }



            } catch (error) {
                console.error('Submission Error:', error);

                let errorMsg = 'Something went wrong. Please try again later.';
                if (error.response?.data?.errors) {
                    const firstError = Object.values(error.response.data.errors)[0];
                    errorMsg = Array.isArray(firstError) ? firstError[0] : firstError;
                } else if (error.response?.data?.message) {
                    errorMsg = error.response.data.message;
                }

                // Swal.fire('Error', errorMsg, 'error');
                Swal.fire({ text: errorMsg, icon: 'error' }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(-1);
                    }
                });
            }
        }
    };

 const handleFileUpload = async (acceptedFiles) => {
  if (!acceptedFiles.length) return;

  // Only take the first image (ignore multiple selections)
  const file = acceptedFiles[0];
  const formData = new FormData();
  formData.append('file', file);

  try {
    const res = await config.userImageUpload(formData);

    // Save only one filename
    const uploadedFile = res.data.filename;

    setFileNames([uploadedFile]); // only one image
    setFormData((prev) => ({
      ...prev,
      image: uploadedFile, // store as string (not array)
    }));
  } catch (error) {
    console.error('Upload error:', error);
    Swal.fire('Error', 'Failed to upload file.', 'error');
  }
};




    return (
        <div className='page-inner'>
            <div className="page-header">
                <h3 className="fw-bold mb-3">Add User</h3>
                <ul className="breadcrumbs mb-3">
                    <li className="nav-home">
                        <a href="#"><i className="fas fa-users"></i></a>
                    </li>
                    <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
                    <li className="nav-item"><a href="#">Users List</a></li>
                    <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
                    <li className="nav-item"><a href="#">Add User</a></li>
                </ul>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className='card'>
                        <div className='card-header'>
                            <div className='card-title'>User Details</div>
                        </div>
                        <div className='card-body'>
                            <Form onSubmit={handleSubmit}>
                                <div className="row">
                                         <div className="col-xl-2 mb-3">
                                        <Form.Group controlId="userType">
                                            <Form.Label>Role</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="userType"
                                                value={formData.userType}
                                                onChange={handleChange}
                                                isInvalid={!!errors.userType}
                                            >
                                                <option value="" disabled>-- Select Role --</option>
                                              <option value="0" >User</option>
                                               <option value="1" >Admin</option>
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">{errors.userType}</Form.Control.Feedback>

                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-2 mb-3">
                                        <Form.Group controlId="propertyId">
                                            <Form.Label>Property Name</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="propertyId"
                                                value={formData.propertyId}
                                                onChange={handleChange}
                                                isInvalid={!!errors.propertyId}
                                            >
                                                <option value="" disabled>-- Select Property --</option>
                                                {propertyOptions.map((opt) => (
                                                    <option key={opt._id} value={opt._id}>{opt.name}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">{errors.propertyId}</Form.Control.Feedback>

                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="name">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.name}
                                                placeholder="Enter Name"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="phone">
                                            <Form.Label>Phone</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                isInvalid={!!errors.phone}
                                                placeholder="Enter Phone"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                </div>

                                <div className="row">
                           
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="email">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                // isInvalid={!!errors.email}
                                                placeholder="Enter Email"
                                            />
                                            {/* <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback> */}
                                        </Form.Group>
                                    </div>
                                             <div className="col-xl-4 mb-3">
                                        <Form.Group>
                                            <Form.Label>Country</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="country"
                                                value={formData.country}
                                                onChange={handleCountryChange}
                                                isInvalid={!!errors.country}
                                            >
                                                <option value="">-- Select Country --</option>
                                                {countries.map((country) => (
                                                    <option key={country.isoCode} value={country.isoCode}>{country.name}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">{errors.country}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group>
                                            <Form.Label>State</Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="state"
                                                value={formData.state}
                                                onChange={handleChange}
                                                isInvalid={!!errors.state}
                                                disabled={!formData.country}
                                            >
                                                <option value="">-- Select State --</option>
                                                {states.map((state) => (
                                                    <option key={state.isoCode} value={state.isoCode}>{state.name}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">{errors.state}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>


                                </div>

                                <div className="row">
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="pincode">
                                            <Form.Label>Pincode</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pincode"
                                                value={formData.pincode}
                                                onChange={handleChange}
                                                isInvalid={!!errors.pincode}
                                                placeholder="Enter Pincode"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.pincode}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="address">
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                name="address"
                                                value={formData.address}
                                                onChange={handleChange}
                                                isInvalid={!!errors.address}
                                                placeholder="Enter Address"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </div>
  <div className="row">
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group>
                                            <Form.Label>Upload File</Form.Label>
 <Dropzone onDrop={handleFileUpload}>
                                            {/* <Dropzone onDrop={handleFileUpload} multiple> */}
                                                {({ getRootProps, getInputProps }) => (
                                                    <div {...getRootProps()} className="dropzone border p-3 rounded text-center" style={{ cursor: 'pointer' }}>
                                                        <input {...getInputProps()} />
                                                        <p>Drag & drop files here, or click to select</p>

                                                        <div className="d-flex flex-wrap justify-content-start mt-2 gap-2">
                                                            {fileNames.map((file, idx) => (
                                                                <div key={idx} className="position-relative">
                                                                    <img
                                                                        src={`${config.BASE_URL}/uploads/users/${file}`}
                                                                        alt={`preview-${idx}`}
                                                                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>


                                            {errors.image && (
                                                <div className="text-danger mt-1">{errors.image}</div>
                                            )}

                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="card-action d-flex gap-2">
                                    <button type="submit" className="btn btn-success">Submit</button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>

                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddUpdateUser;